import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import moment from "moment";

class AbuseExperiencesList extends Component {
  render() {
    const { action } = this.props;
    const abuseExperiences = this.props.abuseExperiences.filter((o) => !o._destroy);

    return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>Type of Abused History</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Notes</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            abuseExperiences.map((l, i) => {
              return (
                <tr key={i}>
                  <td>{l.type_of_abuse}</td>
                  <td>{l.started_at && moment(l.started_at).format("MM/DD/YYYY")}</td>
                  <td>{l.ended_at && moment(l.ended_at).format("MM/DD/YYYY")}</td>
                  <td>{l.notes}</td>
                  <td>
                    {
                      action === "edit" &&
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.editAbuseExperience(l);
                        }}>
                        Edit
                      </a>
                    }
                  </td>
                </tr>
              );
            })
          }
          {
            action == "edit" &&
            <tr>
              <td colSpan={7} className="text-center">
                <Button
                  variant="link"
                  onClick={() => {
                    this.props.newAbuseExperience();
                  }}>
                  Add Abuse History
                </Button>
              </td>
            </tr>
          }
        </tbody>
      </Table>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    abuseExperiences: state.abuse_experiences,
    action: state.ui.action
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    newAbuseExperience: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "abuseExperience" }
      })
    },
    editAbuseExperience: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: { resourceName: "abuseExperience", resource }
      })
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AbuseExperiencesList);
